// extracted by mini-css-extract-plugin
export default {"PrimaryButton":"PrimaryButton_PrimaryButton__mGMq+","Disabled":"PrimaryButton_Disabled__CyIMI","Primary":"PrimaryButton_Primary__teRv4","Secondary":"PrimaryButton_Secondary__QnEoh"};